{"id":"ProductDetail.Info.VariantSelect","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.VariantSelect","options":"options:*"}]}}}